import api from '..';

export async function getMainText() {
  const response = await api.get<{ data: { attributes: { main_text: string } } }>('/vizitka');

  return response.data.data.attributes.main_text;
}
